/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryResponse,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs.ts";

function getGetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsUrl(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsPathParams["courseRegistrationId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/courseregistration/enrollment/${courseRegistrationId}/management-tabs` as const,
  };
  return res;
}

/**
 * @description Retorna quais abas do painel de gerenciamento devem ser exibidas para o usuário autenticado com base no perfil (polo ou não) e nas características da matrícula: existência de monografia, bolsa e processo seletivo. **(Requer Authorization para autenticação)**
 * @summary Retorna as abas visíveis do gerenciamento de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/management-tabs}
 */
export async function getApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabs500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1CourseregistrationEnrollmentCourseregistrationidManagementTabsUrl(
      courseRegistrationId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
